import { atom } from 'jotai';
import type { FolderId, ViewModelId, WorkspaceId } from 'balus-common';

type SidebarControlState = {
  lastOpenedWorkspaceId: WorkspaceId;
  lastOpenedViewModelId: ViewModelId;
  scrolledWorkspaceId: WorkspaceId;
  scrolledViewModelId: ViewModelId;
  scrolledFolderId: FolderId;
};

const initialControlState: SidebarControlState = {
  lastOpenedWorkspaceId: '',
  lastOpenedViewModelId: '',
  scrolledWorkspaceId: '',
  scrolledViewModelId: '',
  scrolledFolderId: '',
};

export const controlAtom = atom<SidebarControlState>(initialControlState);

// サイドバーのコンテナrefを保持するatom
export const sidebarTreeContainerRefAtom = atom<React.RefObject<HTMLDivElement | null> | null>(null);

export const setLastOpenedAtom = atom(
  null,
  (get, set, payload: { lastOpenedWorkspaceId: WorkspaceId; lastOpenedViewModelId?: ViewModelId }) => {
    set(controlAtom, (prev) => ({
      ...prev,
      lastOpenedWorkspaceId: payload.lastOpenedWorkspaceId,
      lastOpenedViewModelId: payload.lastOpenedViewModelId || '',
    }));
  }
);

export const setScrolledWorkspaceAtom = atom(null, (get, set, workspaceId: WorkspaceId) => {
  set(controlAtom, (prev) => ({ ...prev, scrolledWorkspaceId: workspaceId }));
});

export const setScrolledFolderAtom = atom(null, (get, set, folderId: FolderId) => {
  set(controlAtom, (prev) => ({ ...prev, scrolledFolderId: folderId }));
});

export const setScrolledViewModelAtom = atom(null, (get, set, viewModelId: ViewModelId) => {
  set(controlAtom, (prev) => ({ ...prev, scrolledViewModelId: viewModelId }));
});
